import { Post } from "@/shared/dtos/post";
import { Component, Prop, Vue } from "vue-property-decorator";
import postModule from '../../../store/modules/post.module';
import replyModule from '../../../store/modules/reply.module';
import ReplyComponent from '../../../components/forum/reply/reply.component.vue';
import DxTextArea from 'devextreme-vue/text-area';
import DxButton from 'devextreme-vue/button';
import { DxValidator, DxRequiredRule } from 'devextreme-vue/validator';
import { confirm } from 'devextreme/ui/dialog';
import { Reply } from "@/shared/dtos/reply";
import { itiMessageService, itiHttpService } from '@/iti-core-vue';
import { API } from "@/shared/api";
import { ItiIconButton } from '@/iti-core-vuetify';
import collaborativeAreaModule from "@/store/modules/collaborative-area.module";

@Component({
  components: {
    ReplyComponent,
    DxTextArea,
    DxButton,
    DxValidator, 
    DxRequiredRule,
    ItiIconButton,
  }
})
export default class ForumPost extends Vue {
  @Prop() public postId!: number;
  @Prop() public ambitId!: number;
  public post: Post = new Post();
  public collaborativeName: string = '';
  public showReply: boolean = false;
  public reply: Reply = new Reply();

  public created() {
    this.getPost();
    this.getReplys();
    collaborativeAreaModule.getCollaborativeAreaById(Number.parseInt(this.ambitId.toString()));
  }

  public getPost() {
    postModule.getPost(this.postId).then((res: Post) => this.post = res)
    .catch(() => {itiMessageService.toast('No se ha podido cargar el post', 'error', 3000)});
  }

  public getReplys() {
    replyModule.getReplys([this.postId, this.ambitId])
    .catch(() => {itiMessageService.toast('No se han podido cargar las respuestas', 'error', 3000)});
  }

  public responder() {
    this.reply = new Reply();
    this.showReply = !this.showReply;
  }

  public openReplyToEdit(reply: Reply) {
    this.reply = reply;
    this.showReply = true;
  }

  public close() {
    this.responder();
  }

  public save() {
    if(this.reply.id == null) {
      itiMessageService.confirm('¿Está seguro de que desea responder a este post?', this.$tc('mensajes.confirmar'), (result) => {
        if(result) {
          var reply: Reply = new Reply();
          reply.content = this.reply.content;
          reply.postId = this.postId;
          reply.ambitId = this.ambitId;
          replyModule.saveReply(reply)
            .then(() => {this.responder(); itiMessageService.toast('Respuesta guardada con exito', 'success', 3000)})
            .catch(() => itiMessageService.toast('No se ha podido crear la respuesta', 'error', 3000));
        }
      });
    }
    else {
      itiMessageService.confirm('¿Está seguro de que desea editar esta respuesta?', this.$tc('mensajes.confirmar'), (result) => {
        if(result) {
          replyModule.updateReply(this.reply)
            .then(() => {this.responder(); itiMessageService.toast('Respuesta editada con exito', 'success', 3000)})
            .catch(() => itiMessageService.toast('No se ha podido editar la respuesta', 'error', 3000));
        }
      });
    }
  }

  public deletePost() {
    itiMessageService.confirm('¿Está seguro de que desea eliminar este post?', this.$tc('mensajes.confirmar'), (result) => {
      if(result) {
        postModule.deletePost(this.post.id)
          .then(() => {this.$router.back(); itiMessageService.toast('Se ha borrado el post', 'success', 3000)} )
          .catch(() => itiMessageService.toast('No se ha podido borrar el post', 'error', 3000));
      }
    });
  }

  public editPost() {
    postModule.postToEdit(this.post);
    this.$router.push('/main/foro/' + this.ambitId + '/form');
  }

  public get replys() {
    return replyModule.replys;
  }

  public backToHome() {
    this.$router.push({ name: 'Foro', params: { ambitId: this.ambitId.toString() } });            
  }

  public goToAreaHome() {
    this.$router.push({ name: 'CollaborativeAreaDetails', params: { id: this.collaborativeArea.id.toString() } });
  } 

  public get collaborativeArea() {
    return collaborativeAreaModule.selectedCollaborativeArea;
  }

}
